import {Row, Spin} from "antd";

const Loading = () => {
    return <Row justify="center" align="center"><Spin tip="Chargement..."/></Row>;
}

export default Loading;
